import { ref } from 'vue';
import { EntityItem } from '@/entities/entityItem';

export const useEntityItemRecord = () => ref<EntityItem>({
  title: '',
  description: '',
  entityTypeId: null,
  users: [],
  primarySsid: '',
  primaryPassword: '',
  secondarySsid: '',
  secondaryPassword: '',
  properties: [],
});
